export const copy = (text: string): Promise<void> => {
  if ('clipboard' in navigator) {
    return navigator.clipboard.writeText(text);
  }

  return Promise.reject(new Error('Copy to clipboard is not supported in your browser'));
};
